// Verbatim port of apps/web-svelte/src/lib/api/error.ts.
// v3 backend error normalization — every service emits the same
// { error: { code, message, details? } } envelope.

export type ApiErrorCode = "NETWORK" | "UNKNOWN" | "PARSE_ERROR" | (string & {});

export class ApiError extends Error {
  readonly status: number;
  readonly code: ApiErrorCode;
  readonly details: Record<string, unknown> | undefined;

  constructor(opts: {
    status: number;
    code: ApiErrorCode;
    message: string;
    details?: Record<string, unknown>;
  }) {
    super(opts.message);
    this.name = "ApiError";
    this.status = opts.status;
    this.code = opts.code;
    this.details = opts.details;
  }
}

type V3ErrorEnvelope = {
  error?: {
    code?: string;
    message?: string;
    details?: Record<string, unknown>;
  };
};

export function fromHttpResponse(status: number, body: unknown): ApiError {
  const env = (body ?? {}) as V3ErrorEnvelope;
  const code = env.error?.code ?? "UNKNOWN";
  const message = env.error?.message ?? `Request failed with status ${status}`;
  const details = env.error?.details;
  return new ApiError(
    details === undefined ? { status, code, message } : { status, code, message, details }
  );
}

export function fromNetworkError(err: unknown): ApiError {
  const message = err instanceof Error ? err.message : "Network request failed";
  return new ApiError({ status: 0, code: "NETWORK", message });
}
